import { render, staticRenderFns } from "./new-group.vue?vue&type=template&id=19c4e78a&scoped=true&"
import script from "./new-group.vue?vue&type=script&lang=js&"
export * from "./new-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4e78a",
  null
  
)

export default component.exports